import React from "react";
import "../../../index.css";
import "../../../App.css";
import Booking from "../../../helper/svg/booking.svg";
import Finance from "../../../helper/svg/Finance.svg";
import Support from "../../../helper/svg/Support.svg";
import Platform from "../../../helper/svg/Platform.svg";
import Secure from "../../../helper/svg/secure.svg";
import { useTranslation } from "../../../hooks/useTranslation";
const WhyChoose = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="lg:py-[100px] md:py-[70px] py-[30px]">
        <div className="container">
          <h2 className="text-center text-[#18181B] lg:text-[40px] md:text-[30px] text-[25px] font-semibold lg:leading-[47px] leading-9 mb-5">
            {t("about").whyChoose.title}
          </h2>
          <p className="text-lg leading-[]30px text-center text-[#18181B]">
            {t("about").whyChoose.subtitle}
          </p>
          {/* Cards */}

          <div className="flex mt-[35px] gap-[21px] justify-center flex-wrap">
            <div className="md:py-[30px] md:px-[25px] py-5 px-4 rounded-[10px] card-shadow lg:w-[32%] md:w-[48%] w-full">
              <img
                src={Booking}
                alt="booking"
                className="max-w-[70px] mx-auto mb-[24px]"
              />
              <h3 className="text-center text-[22px] font-semibold text-[#18181B] mb-[15px]">
                {t("about").whyChoose.cards.booking.title}
              </h3>
              <p className="text-center text-lg leading-[30px]">
                {t("about").whyChoose.cards.booking.description}
              </p>
            </div>
            <div className="md:py-[30px] md:px-[25px] py-5 px-4 rounded-[10px] card-shadow lg:w-[32%] md:w-[48%] w-full">
              <img
                src={Finance}
                alt="booking"
                className="max-w-[70px] mx-auto mb-[24px]"
              />
              <h3 className="text-center text-[22px] font-semibold text-[#18181B] mb-[15px]">
                {t("about").whyChoose.cards.finance.title}
              </h3>
              <p className="text-center text-lg leading-[30px]">
                {t("about").whyChoose.cards.finance.description}
              </p>
            </div>
            <div className="md:py-[30px] md:px-[25px] py-5 px-4 rounded-[10px] card-shadow lg:w-[32%] md:w-[48%] w-full">
              <img
                src={Support}
                alt="booking"
                className="max-w-[70px] mx-auto mb-[24px]"
              />
              <h3 className="text-center text-[22px] font-semibold text-[#18181B] mb-[15px]">
                {t("about").whyChoose.cards.support.title}
              </h3>
              <p className="text-center text-lg leading-[30px]">
                {t("about").whyChoose.cards.support.description}
              </p>
            </div>
            <div className="md:py-[30px] md:px-[25px] py-5 px-4 rounded-[10px] card-shadow lg:w-[32%] md:w-[48%] w-full">
              <img
                src={Platform}
                alt="booking"
                className="max-w-[70px] mx-auto mb-[24px]"
              />
              <h3 className="text-center text-[22px] font-semibold text-[#18181B] mb-[15px]">
                {t("about").whyChoose.cards.platform.title}
              </h3>
              <p className="text-center text-lg leading-[30px]">
                {t("about").whyChoose.cards.platform.description}
              </p>
            </div>
            <div className="md:py-[30px] md:px-[25px] py-5 px-4 rounded-[10px] card-shadow lg:w-[32%] md:w-[48%] w-full">
              <img
                src={Secure}
                alt="booking"
                className="max-w-[70px] mx-auto mb-[24px]"
              />
              <h3 className="text-center text-[22px] font-semibold text-[#18181B] mb-[15px]">
                {t("about").whyChoose.cards.secure.title}
              </h3>
              <p className="text-center text-lg leading-[30px]">
                {t("about").whyChoose.cards.secure.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyChoose;
